export default {
  title: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_title',
    defaultMessage: 'The reviews speak for themselves',
  },
  alternativeNext: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_alternative_next',
    defaultMessage: 'Next review',
  },
  alternativePrevious: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_alternative_previous',
    defaultMessage: 'Previous review',
  },
  review1Score: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_1_score',
    defaultMessage: '4.4',
  },
  review1Text: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_1_text',
    defaultMessage:
      'This is my third iPhone purchased from Back Market. Each order was very good and the service with Visible seems working out very well also.',
  },
  review1Author: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_1_author',
    defaultMessage: 'May K.',
  },
  review2Score: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_2_score',
    defaultMessage: '5',
  },
  review2Text: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_2_text',
    defaultMessage:
      'Great! Looked new to me - didn’t see any flaws. Functions as I hoped and even better. Works well with Visible plan.',
  },
  review2Author: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_2_author',
    defaultMessage: 'James C.',
  },
  review3Score: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_3_score',
    defaultMessage: '5',
  },
  review3Text: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_3_text',
    defaultMessage:
      'Amazing. Everything from start to finish to simple and smooth. We even got a discount with Visible 24 months just for buying the phone. Also, the phone came in excellent condition as advertised.',
  },
  review3Author: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_3_author',
    defaultMessage: 'Todd C.',
  },
  review4Score: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_4_score',
    defaultMessage: '4.9',
  },
  review4Text: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_4_text',
    defaultMessage:
      'Exactly as described. Easy setup. We went with Visible service and there were no issues.',
  },
  review4Author: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_4_author',
    defaultMessage: 'Matt W.',
  },
  review5Score: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_5_score',
    defaultMessage: '5',
  },
  review5Text: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_5_text',
    defaultMessage:
      'Very east to set up with US Mobile. Good bye Verizon -- forever.',
  },
  review5Author: {
    id: 'us_telco_comparators_landing_page_reviews_carousel_review_5_author',
    defaultMessage: 'Andrew D.',
  },
}
